export default "__VITE_ASSET__Cica3xfB__"